import {api} from 'macarons'
import customGraphApi from './api'

export default {
  namespaced: true,
  state () {
    return {
      queryCache: {
      },
      measures: {
        data: [],
        loading: null
      },
      dimensions: {
        data: [],
        loading: null,
        state: {}
      },
      universes: {
        data: [],
        loading: null
      },
      views: {
        data: [],
        loading: null
      },
      listeners: {
      },
      filters: {
      }
    }
  },
  getters: {
    filter: state => key => {
      return state.filters[key]
    },
    universes (state) {
      if (state.universes && state.universes.data) {
        return state.universes.data
      }
      return []
    },
    measures (state) {
      if (state.measures && state.measures.data) {
        return state.measures.data
      }
      return []
    },
    views (state) {
      if (state.views && state.views.data) {
        return state.views.data
      }
      return []
    },
    dimensions (state) {
      if (state.dimensions && state.dimensions.data) {
        return state.dimensions.data
      }
      return []
    },
    dimension: state => id => {
      const dim = id.split('].[')
      const parent = state.dimensions.data.find(d => {
        return customGraphApi.dimension.uniqueName(d) === dim[0] + ']'
      })
      if (dim.length === 1) {
        return parent
      }
      return parent.children.find(d => customGraphApi.dimension.uniqueName(d) === id)
    }
  },
  mutations: {
    clearCache (state) {
      Object.keys(state.queryCache).forEach(key => {
        delete state.queryCache[key]
      })
      state.measures.data.splice(0, state.measures.data.length)
      state.measures.loading = null
      state.views.data.splice(0, state.views.data.length)
      state.views.loading = null
      state.dimensions.data.splice(0, state.dimensions.data.length)
      state.dimensions.loading = null
      Object.keys(state.dimensions.state).forEach(key => {
        delete state.dimensions.state[key]
      })
    },
    addEventListener (state, data) {
      if (typeof state.listeners[data.event] === 'undefined') {
        state.listeners[data.event] = [{ handler: data.handler, weight: data.weight || 0 }]
      }
      else {
        const index = state.listeners[data.event].findIndex(h => h.handler === data.handler)
        if (index === -1) {
          state.listeners[data.event].push({ handler: data.handler, weight: data.weight || 0 })
        } else {
          state.listeners[data.event][index].weight = data.weight
        }
      }
      state.listeners[data.event].sort((h1, h2) => {
        return h1.weight === h2.weight ? 0 : (h1.weight > h2.weight)
      })
    },
    removeEventListener (state, data) {
      if (typeof state.listeners[data.event] !== 'undefined') {
        const index = state.listeners[data.event].findIndex(h => h.handler === data.handler)
        if (index !== -1) {
          state.listeners[data.event].splice(index, 1)
        }
      }
    },
    setFilter (state, data) {
      state.filters[data.key] = data.values
    },
    setUniverses (state, universes) {
      state.universes.data.splice(0, state.universes.data.length, ...universes)
    },
    setMeasures (state, measures) {
      state.measures.data.splice(0, state.measures.data.length, ...measures)
    },
    setViews (state, views) {
      state.views.data.splice(0, state.views.data.length, ...views)
    },
    setDimensions (state, dimensions) {
      if (!Array.isArray(dimensions)) {
        console.log('THIS IS NOT AN ARRAY', dimensions)
      } else {
        dimensions.forEach(d => {
          d.children = []
          d.values = []
        })
        state.dimensions.data.splice(0, state.dimensions.data.length, ...dimensions)
      }
    },
    setHierarchy (state, data) {
      const dimension = state.dimensions.data.find(d => {
        return customGraphApi.dimension.uniqueName(d) === data.dimension
      })
      if (dimension) {
        data.children.forEach(d => {
          d.values = []
        })
        dimension.children.splice(0, dimension.children.length, ...data.children)
      }
    },
    setValues (state, data) {
      const dim = data.dimension.split('].[')
      let dimension = state.dimensions.data.find(d => {
        return customGraphApi.dimension.uniqueName(d) === dim[0] + ']'
      })
      if (typeof dimension === 'undefined') {
        return
      }
      if (dim.length === 2) {
        dimension = dimension.children.find(d => {
          return customGraphApi.dimension.uniqueName(d) === data.dimension
        })
        if (typeof dimension === 'undefined') {
          return
        }
      }
      dimension.values.splice(0, dimension.values.length, ...data.values.filter(v => {
        return v.uniqueName.substr(-6) !== '.[All]' && v.uniqueName.substr(-14) !== '.UNKNOWNMEMBER'
      }))
    }
  },
  actions: {
    async emitEvent ({state, dispatch}, event) {
      if (typeof state.listeners[event.event] !== 'undefined') {
        for (let index = 0; index < state.listeners[event.event].length; ++index) {
          await state.listeners[event.event][index].handler(event)
        }
      }
    },
    async loadUniverses ({state, dispatch, commit}) {
      if (state.universes.loading === null) {
        state.universes.loading = dispatch('DSNQuery', {
          route: 'metadata/universes'
        })
        commit('setUniverses', await state.universes.loading)
      }
      return state.universes.loading
    },
    async loadMeasures ({state, rootState, dispatch, commit}) {
      if (state.measures.loading === null) {
        const data = {
          route: customGraphApi.measure.routes.list,
          includeDimensions: true
        }
        if (rootState.board.data && rootState.board.data.universe) {
          data.universe = rootState.board.data.universe
        }
        state.measures.loading = dispatch('DSNQuery', data)
        commit('setMeasures', await state.measures.loading)
      }
      return state.measures.loading
    },
    async loadViews ({state, rootState, dispatch, commit}) {
      if (state.views.loading === null) {
        const data = {
          route: 'metadata/views',
          includeColumns: true
        }
        if (rootState.board.data && rootState.board.data.universe) {
          data.universe = rootState.board.data.universe
        }
        state.views.loading = dispatch('DSNQuery', data)
        commit('setViews', await state.views.loading)
      }
      return state.views.loading
    },
    async loadDimensions ({state, dispatch, commit, rootState}) {
      if (state.dimensions.loading === null) {
        const data = {
          route: customGraphApi.dimension.routes.list
        }
        if (rootState.board.data && rootState.board.data.universe) {
          data.universe = rootState.board.data.universe
        }
        state.dimensions.loading = dispatch('DSNQuery', data)
        commit('setDimensions', await state.dimensions.loading)
      }
      return state.dimensions.loading
    },
    async loadDimension ({state, dispatch, commit, rootState}, dimension) {
      await dispatch('loadDimensions')
      const dim = dimension.split('].[')
      if (dim.length > 1) {
        dimension = dim[0] + ']'
      }
      if (typeof state.dimensions.state[dimension] === 'undefined') {
        const data = {
          route: customGraphApi.dimension.routes.hierarchies,
          dimension: dimension
        }
        if (rootState.board.data && rootState.board.data.universe) {
          data.universe = rootState.board.data.universe
        }
        state.dimensions.state[dimension] = dispatch('DSNQuery', data)
        commit('setHierarchy', {
          dimension: dimension,
          children: await state.dimensions.state[dimension]
        })
      }
      return state.dimensions.state[dimension]
    },
    async loadValues ({state, dispatch, commit, rootState}, dimension) {
      await dispatch('loadDimension', dimension)
      if (typeof state.dimensions.state[dimension + '@values'] === 'undefined') {
        const data = {
          route: customGraphApi.dimension.routes.members,
          hierarchy: dimension
        }
        if (rootState.board.data && rootState.board.data.universe) {
          data.universe = rootState.board.data.universe
        }
        state.dimensions.state[dimension + '@values'] = dispatch('DSNQuery', data)
        commit('setValues', {
          dimension: dimension,
          values: await state.dimensions.state[dimension + '@values']
        })
      }
      return state.dimensions.state[dimension + '@values']
    },
    async execute ({state, dispatch, rootState}, query) {
      const event = { event: 'executeQuery', query: query }
      await dispatch('emitEvent', event)
      if (event.prevent) {
        return { data: [], metadata: null, message: event.preventMessage }
      }
      const hash = JSON.stringify(query)
      if (typeof state.queryCache[hash] === 'undefined') {
        query.route = customGraphApi.data.routes.query
        if (rootState.board.data && rootState.board.data.universe) {
          query.universe = rootState.board.data.universe
        }
        if (!window[window.macarons].cache.DSN) {
          return dispatch('DSNQuery', query)
        }
        state.queryCache[hash] = dispatch('DSNQuery', query)
      }
      return state.queryCache[hash].catch(err => {
        setTimeout(() => {
          delete state.queryCache[hash]
        }, 100)
        throw err
      })
    },
    async DSNQuery (context, query) {
      if (typeof query.route === 'undefined') {
        return Promise.reject(new Error('Le paramètre "route" est obligatoire'))
      }
      const qs = new URLSearchParams()
      Object.keys(query).forEach(k => {
        if (k !== 'route' && k !== 'axios') {
          if (Array.isArray(query[k])) {
            qs.set(k, query[k].join(','))
          } else {
            qs.set(k, query[k])
          }
        }
      })
      const options = {
        headers: {
          'X-Target-Url': window[window.macarons].DSN + query.route,
          'X-Target-Method': customGraphApi.target.method,
          'X-Requested-With': 'XMLHttpRequest'
        }
      }
      if (typeof query.axios !== 'undefined') {
        Object.keys(query.axios).forEach(k => {
          options[k] = query.axios[k]
        })
      }
      return api.post('proxy', qs, options).then(response => response.data)
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/macarons-graphs-front/src/store.js